import { useRef, useState, useCallback } from 'react';

function useBinding(defaultValue, value, onChange, fallbackValue) {
  let hasControlledValue = false;
  let inputValue;
  if (isDefined(value)) {
    hasControlledValue = true;
    inputValue = value;
  } else if (isDefined(defaultValue)) {
    inputValue = defaultValue;
  } else if (isDefined(fallbackValue)) {
    inputValue = fallbackValue;
  }
  const controlledValueRef = useRef(hasControlledValue);
  if (controlledValueRef.current !== hasControlledValue) {
    console.warn(`WARN: A component changed from ${controlledValueRef.current ? 'controlled' : 'uncontrolled'} to ${hasControlledValue ? 'controlled' : 'uncontrolled'}.`);
    controlledValueRef.current = hasControlledValue;
  }
  const [uncontrolledValue, setUncontrolledValue] = useState(inputValue);
  const changeHandler = onChange || noop;
  const currentValueRef = useRef();
  currentValueRef.current = hasControlledValue ? inputValue : uncontrolledValue;
  const setter = useCallback(newValue => {
    const evaluatedNewValue = typeof newValue === 'function' ? newValue(currentValueRef.current) : newValue;
    currentValueRef.current = evaluatedNewValue;
    changeHandler(evaluatedNewValue);
    if (!hasControlledValue) {
      setUncontrolledValue(evaluatedNewValue);
    }
  }, [currentValueRef, changeHandler, hasControlledValue]);
  return [currentValueRef.current, setter];
}
function noop(_) {
  // Nothing.
}
function isDefined(value) {
  return typeof value !== 'undefined';
}

export { useBinding };
//# sourceMappingURL=useBinding.js.map
